import { Component, OnInit } from '@angular/core';
import { EnvState } from 'src/app/modules/shared/helpers/env-state';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss']
})
export class LogoComponent implements OnInit {

  constructor(public env: EnvState) { }

  ngOnInit(): void {
  }

}
